import { apiClient } from "@/api-client";
import type { PluginContext } from "@/types/common";
import { ApiClientKey } from "@/types/symbols";

export default function ({ app }: PluginContext) {
  app.provide(ApiClientKey, apiClient);
}
